<template>
  <div id="side-menu">
    <div v-bind:class="{hamburger: true, 'hamburger--spin': true,
                        'is-active': showSideMenu, hide: hideMenuButton,
                        'need-notif-perm': showNotifPerm && !showSideMenu}"
         @click="toggleMenu">
      <div class="hamburger-box">
        <div class="hamburger-inner"></div>
      </div>
    </div>
    <div v-bind:class="{'side-menu': true, hide: !this.$store.state.sideMenu.show}">
      <div class="user">
        <img :src="user.photoUrl" />
        <div class="name">{{user.firstName}} {{user.lastName}}</div>
        <div class="logout">
          <span>Not {{user.firstName}}?</span>
          <a v-bind:class="{ disabled: loggingOut }" href="javascript:;" @click="logout">
            <span v-show="!loggingOut">Logout</span>
            <i v-show="loggingOut" class="fas fa-spinner fa-spin fa-fw"></i>
          </a>
        </div>
        <div class="search-toggle">
          <span>Global Search:</span>
          <label class="switch">
            <input type="checkbox" :checked="enableSearchGlobal" @click="toggleGlobalSearch">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <ul>
        <li><router-link :to="{ name: 'Transactions' }">{{ $t('sideMenu.transactions') }}</router-link></li>
        <li @click="createRsvp"><a>Create Reservation</a></li>
        <li><router-link :to="{ name: 'ImportRsvp' }">Import Reservation</router-link></li>
        <li><router-link :to="{ name: 'Dispatch' }">{{ $t('sideMenu.dispatch') }}</router-link></li>
        <li><router-link :to="{ name: 'DispatchLaxit' }">{{ $t('sideMenu.laxit') }}</router-link></li>
        <li><router-link :to="{ name: 'Runs' }">Runs</router-link></li>
        <li><router-link :to="{ name: 'Routing' }">{{ $t('sideMenu.routing') }}</router-link></li>
        <li><router-link :to="{ name: 'Flights' }">Flights</router-link></li>
        <li><router-link :to="{ name: 'Corporate' }">Corporate Accounts</router-link></li>
        <li><router-link :to="{ name: 'ConsumerList' }">{{ $t('sideMenu.consumers') }}</router-link></li>
        <li><router-link :to="{ name: 'ProviderList' }">{{ $t('sideMenu.providers') }}</router-link></li>
        <li><router-link :to="{ name: 'ProviderAvailability' }">{{ $t('sideMenu.providerAvailability') }}</router-link></li>
        <li><router-link :to="{ name: 'ProviderDeductions' }">{{ $t('sideMenu.providerDeductions') }}</router-link></li>
        <li><router-link :to="{ name: 'ProviderPayouts' }" v-if="payoutsAccess">{{ $t('sideMenu.providerPayouts') }}</router-link></li>
        <li><router-link :to="{ name: 'Geofence' }">{{ $t('sideMenu.geofences') }}</router-link></li>
        <li><router-link :to="{ name: 'Pricing' }">{{ $t('sideMenu.pricing') }}</router-link></li>
        <li><router-link :to="{ name: 'Services' }">{{ $t('sideMenu.serviceTypes') }}</router-link></li>
        <li><router-link :to="{ name: 'Reports' }">{{ $t('sideMenu.reports') }}</router-link></li>
        <li><router-link :to="{ name: 'Insurance' }" v-if="insuranceAccess">Insurance</router-link></li>
        <li><router-link :to="{ name: 'MarketingAds' }">{{ $t('sideMenu.marketingAds') }}</router-link></li>
        <li><router-link :to="{ name: 'PromoList' }">{{ $t('sideMenu.promo') }}</router-link></li>
        <li><router-link :to="{ name: 'Discount Codes' }">Discount Codes</router-link></li>
        <li><router-link :to="{ name: 'Brands' }">{{ $t('sideMenu.brands') }}</router-link></li>
        <li><router-link :to="{ name: 'Filters' }">{{ $t('sideMenu.filters') }}</router-link></li>
        <li><router-link :to="{ name: 'Admin' }">{{ $t('sideMenu.admin') }}</router-link></li>
        <li><router-link :to="{ name: 'Settings' }">{{ $t('sideMenu.settings') }}</router-link></li>
      </ul>

      <notification-permission></notification-permission>
    </div>
    <div v-bind:class="{'side-menu-cover': true, hide: !this.$store.state.sideMenu.show}" @click="toggleMenu"></div>
  </div>
</template>

<script>
import NotificationPermission from './NotificationPermission'

export default {
  name: 'side-menu',
  components: { NotificationPermission },
  data () {
    return {
      loggingOut: false,
      showImport: false,
      hideImportNav: false
    }
  },
  computed: {
    user () { return this.$store.state.session.user },
    sideMenu () { return this.$store.state.sideMenu },
    showSideMenu () { return this.sideMenu.show },
    hideMenuButton () { return !this.sideMenu.showMenuButton },
    showNotifPerm () { return this.$store.state.notificationPermission.show },
    _userID () { return this.user.id },
    _route () { return this.$route.name },
    enableSearchGlobal () { return this.$store.state.searchGlobal.enable },
    payoutsAccess () { return this.user.access && this.user.access.hasOwnProperty('PageAdminDriverBatchModifications') },
    insuranceAccess () { return this.user.access && this.user.access.hasOwnProperty('PageAdminInsurance') }
  },
  methods: {
    toggleGlobalSearch () {
      let self = this
      localStorage.setItem('searchGlobal', !self.enableSearchGlobal)
      self.$store.commit('searchGlobal/setSearchGlobalEnable', !self.enableSearchGlobal)
    },
    toggleMenu () {
      if (this.sideMenu.show) {
        this.showImport = false
        this.$store.commit('sideMenu/hide')
      } else {
        this.$store.commit('sideMenu/show')
      }
    },
    createRsvp () { window.location.href = '#/reservation/new' },
    logout () {
      let self = this
      self.loggingOut = true
      self.$sdk.post('/admin/logout', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.loggingOut = false
        if (r.error) {
          console.log(r)
          return
        }
        self.$plugins.fcm.deleteToken(self)
        self.$plugins.storage.removeSessionToken()
        window.location.reload()
      })
    },
    getAccess () {
      let self = this
      let user = self.user

      if (user.id && !user.access && !user.loading) {
        self.$store.commit('session/setAccessLoading', true)
        self.$sdk.get('/admin/' + user.id + '/access',{
          token: self.$store.state.session.sessionToken
        }, function (r) {
          self.$store.commit('session/setAccessLoading', false)
          if (!r.error) {
            self.$store.commit('session/setAccess', r.permissions)
            self.checkAccess()
          }
        })
      }
    },
    checkAccess () {
      let self = this
      let user = self.user
      // console.log('ROUTE:', self._route)
      // console.log('ACCESS:', user.access)

      if (!user.access) {
        setTimeout(function () { self.checkAccess() }, 300)
        return
      }

      if (['Provider', 'ProviderList'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminDashboard')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Consumer', 'ConsumerList'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminConsumers')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Corporate', 'CreateCorporate', 'CorporateProfile'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminCorporates')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Home', 'Transactions'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminTransactions')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['ImportRsvp'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminImport')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Promo'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminPromocodes')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Ratings'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminRatings')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Bids'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminBids')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['MarketingAds'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminAds')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Fleet'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminFleetReport')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Logs'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminLog')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Notifcations'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminNotifications')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Maps'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminMap')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Geo'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminGeo')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Pricing'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminPricing')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Services'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminService')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Settings'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminSettings')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['StagingLot'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminStagingLot')
      ) {
        self.$router.push('/accessdenied')
      }

      // Non-exist
      if (['Filter'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminFilter')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['RsvpDetails', 'PackageDetails'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminRSVP')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Dispatch', 'DispatchReservations'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminDispatch')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Laxit', 'DispatchLaxit'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminLaxit')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Routing'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminRouting')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Brands'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminBrands')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Admin'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminAdmins')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['Reports'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminReports')
      ) {
        self.$router.push('/accessdenied')
      }

      if (['ProviderDeductions'].indexOf(self._route) > -1 &&
        !user.access.hasOwnProperty('PageAdminProviderDeductions')
      ) {
        self.$router.push('/accessdenied')
      }
    }
  },
  watch: {
    _userID: function (value) { if (value) { this.getAccess() } },
    _route: function (value) { this.checkAccess() }
  },
  mounted () {
    this.getAccess()
    if (!!localStorage.getItem('searchGlobal')) {
      this.$store.commit('searchGlobal/setSearchGlobalEnable', localStorage.getItem('searchGlobal') === 'true')
    }

    let user = this.user
    if (user.access && !user.access.hasOwnProperty('PageAdminImport')) {
      this.hideImportNav =  true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_hamburger';

.side-menu-cover{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  transition: all 300ms ease;
  opacity: 1;

  &.hide{
    top: -100%;
    opacity: 0;
  }
}
.side-menu{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  width: 250px;
  height: 100%;
  background-color: #2A2D33;
  overflow: auto;
  box-shadow: 2px 2px 4px rgba(0,0,0,0.35);
  transition: all 250ms;

  &.hide{
    left: -255px;
  }


  & .user{
    & img{
      display: block;
      width: 80px;
      height: 80px;
      margin: 20px auto 10px;
      border-radius: 50%;
    }

    & .name{
      text-align: center;
      font-weight: 700;
      font-size: 20px;
      text-align: center;
      padding: 0 15px;
      color: #fff;
    }

    & .logout{
      font-size: 14px;
      color: #fff;
      // padding: 0 15px 20px;
      text-align: center;

      & a{ font-weight: 700; }
    }
  }

  .search-toggle {
    color: #fff;
    padding: 10px 20px;
    font-size: 14px;
    text-align: center;

    span {
      margin-right: 10px;
    }
    .switch {
      position: relative;
      display: inline-block;
      width: 50px;
      height: 20px;
      bottom: -2px;
    }

    /* Hide default HTML checkbox */
    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    /* The slider */
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: .4s;
      transition: .4s;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 14px;
      width: 14px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      -webkit-transition: .4s;
      transition: .4s;
    }

    input:checked + .slider {
      background-color: #2196F3;
    }

    input:focus + .slider {
      box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
      -webkit-transform: translateX(20px);
      -ms-transform: translateX(20px);
      transform: translateX(20px);
    }

    .slider.round {
      border-radius: 34px;
    }

    .slider.round:before {
      border-radius: 50%;
    }
  }

  & ul{
    padding: 0;
    margin: 0;
    list-style-type: none;
    display: block;

    & li{
      display: block;

      & a{
        padding: 10px 20px;
        display: block;
        border-bottom: 1px solid #222;
        border-top: 1px solid #444;
        color: #eee;
        text-decoration: none;
      }
    }
  }
}

.hamburger{
  width: 50px;
  height: 50px;
  position: fixed;
  padding: 13px 14px;
  z-index: 12;
  top: 0;
  left: 0;
  background-color: #57D1B7;
  transition: all 250ms;
  box-shadow: 0 2px 4px rgba(0,0,0,0.15);

  &.hide{ left: -50px; }

  &:hover{ opacity: 1; }

  & .hamburger-inner,
  & .hamburger-inner:after,
  & .hamburger-inner:before{
    background-color: #fff;
    width: 20px;
    height: 3px;
  }
  & .hamburger-inner:before{ top: -6px; }
  & .hamburger-inner:after{ bottom: -6px; }

  &.is-active{
    background-color: #2A2D33;
    box-shadow: 0 2px 4px rgba(0,0,0,0);
  }

  &.need-notif-perm{
    &:before{
      content: '';
      display:block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      webkit-box-shadow:inset 0 0 0 4px #ec6b24;
      -moz-box-shadow:inset 0 0 0 4px #ec6b24;
      box-shadow:inset 0 0 0 4px #ec6b24;
      opacity: 0;
      animation: border-pulsate 1.2s linear infinite;
    }
  }
}
a{ cursor: pointer; }
a.disabled {
  pointer-events: none;
  color: #ddd;
  transition: all 250ms;
}

@keyframes border-pulsate{
  0%, 100%{
    webkit-box-shadow:inset 0 0 0 0 #ec6b24;
    -moz-box-shadow:inset 0 0 0 0 #ec6b24;
    box-shadow:inset 0 0 0 0 #ec6b24;
    opacity: 0;
  }
  50%{
    webkit-box-shadow:inset 0 0 0 4px #ec6b24;
    -moz-box-shadow:inset 0 0 0 4px #ec6b24;
    box-shadow:inset 0 0 0 4px #ec6b24;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/SideMenu.vue